export const pics = {
  canaveral: Math.round(Math.random())
    ? "https://live.staticflickr.com/65535/50137510881_3f675bb620_h.jpg"
    : "https://live.staticflickr.com/65535/51134975562_11a63a62d7_h.jpg",
  starbase: "https://live.staticflickr.com/65535/50906488116_c44db82fc1_k.jpg",
  vandenberg: "https://live.staticflickr.com/982/42290930181_480260c49b_k.jpg",
};
